export default {
    item: {
        setData: 'MARKETING_STORE_PACKAGE_ITEM_SET_DATA',
        setLoading: 'MARKETING_STORE_PACKAGE_ITEM_SET_LOADING',
    },
};
